<template>
  <vs-table v-if="show" ref="table" :params="params" :options="options"></vs-table>
</template>

<script>
import VsTable from "../_framework/VsTable.vue";
import Vue from "vue";
import VoucherTypeSelect from "../components/VoucherTypeSelect";

export default {
  name: "voucher-type",
  created: () => {},
  beforeMount() {
    this.options.access = checkAccess(this.$route.path);
    //console.log(this.options.access);
    this.show = this.options.access ? true : false;
  },
  components: {
    VsTable
  },
  data() {
    return {
      show: true,
      params: {
        access: {},
        entity: "documentTypes",
        headers: {
          type: {
            title: "نوع سند",
            type: "custom",
            component: "voucher-type-select",
            label: "name",
            multiple: false
            /*listParams: {
                                requestURI: "documentTypes"
                            }*/
          },
          name: {
            title: "عنوان",
            type: "text"
          }
        }
      },
      options: {
        hasActions: true,
        hasActionsInHeader: true,
        beforeDeleteEntity: input => {
          this.refreshTable();
          return input;
        },
        beforeCreateEntity: input => {
          if (!this.valid(input)) {
            return -1;
          }
          this.refreshTable();
          return input;
        },
        beforeUpdateEntity: input => {
          if (input.type && typeof input.type === "object") {
            input.type = input.type.value;
          }
          if (!this.valid(input)) {
            return;
          }
          this.refreshTable();
          return input;
        },
        getTopRightButtons: () => {
          let arr = [];
          let searchToggleButton = {
            component: "search-toggle-button"
          };
          arr.push(searchToggleButton);
          return arr;
        },
        getTopLeftButtons: () => {
          let arr = [];
          let self = this;
          let addItemButton = {
            component: "toggle-table-actions-button",
            params: {
              onClick() {
                self.options.hasActions = !self.options.hasActions;
              }
            }
          };
          arr.push(addItemButton);
          return arr;
        }
        /*onEditClicked: (context, row) => {
                        let ComponentClass = Vue.extend(VoucherTypeSelect);
                        let voucherSelect = new ComponentClass({
                            propsData: {
                                params: {
                                    mode: 'edit'
                                }
                            }
                        });
                        voucherSelect.$data.selectedType = [context.type];
                    }*/
      }
    };
  },
  methods: {
    valid(data) {
      if (!data.type) {
        this.$noty.error("نوع سند را انتخاب نمائید");
        return false;
      }
      if (!data.name) {
        this.$noty.error("عنوان را وارد نمائید");
        return false;
      }
      return true;
    },
    refreshTable() {
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 100);
    }
  }
};
</script>